module.exports = __webpack_public_path__ + "img/taiban.24a84264.svg";